export const prestaMixin = {
    data() {
        return {
            dataArray: "",
            sessionData: null,
            imgArray: []
        }
    },
    beforeMount() {
        this.connectPresta();
        this.createimgArray();
    },
    methods: {
        connectPresta() {
            this.sessionData = sessionStorage.getItem('dataArray');

            if(this.sessionData === null) {
                fetch(
                    "https://ws-gbbu02.graphibox.eu/WebService.asmx/GetAchievements",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            pKey: "Q2D9B598uD87LecZJ22tSd3j2ZrPbggf",
                            // pId: id,
                            // pIdCat: 0,
                            // pNbItems: nbItems
                        })
                    }
                )
                .then(function(res) {
                    return res.json();
                })
                .then(res => {
                    let response = JSON.parse(res.d);
                    // console.log(response)
                    this.dataArray = response;
                    sessionStorage.setItem('dataArray', JSON.stringify(response))
                }) 
            } else {
                this.dataArray = JSON.parse(this.sessionData)
            }
        },
        createimgArray() {
            for(var i = 0; i < this.dataArray.length; i++) {
                let provisoire = []
                    if(this.dataArray[i].picture01A != null) {
                        provisoire.push(this.dataArray[i].picture01A)
                    }
                    if(this.dataArray[i].picture02A != null) {
                        provisoire.push(this.dataArray[i].picture02A)
                    }
                    if(this.dataArray[i].picture03A != null) {
                        provisoire.push(this.dataArray[i].picture03A)
                    }
                    if(this.dataArray[i].picture04A != null) {
                        provisoire.push(this.dataArray[i].picture04A)
                    }
                    if(this.dataArray[i].picture05A != null) {
                        provisoire.push(this.dataArray[i].picture05A)
                    }
                    if(this.dataArray[i].picture06A != null) {
                        provisoire.push(this.dataArray[i].picture06A)
                    }
                    if(this.dataArray[i].picture07A != null) {
                        provisoire.push(this.dataArray[i].picture07A)
                    }
                    if(this.dataArray[i].picture08A != null) {
                        provisoire.push(this.dataArray[i].picture08A)
                }
                this.imgArray.push(provisoire)
            }
        },
        imageUrl(id, imageName) {
            return 'https://cdn-gbbu02.graphibox.eu/pub/4/medias/achievements/' + id + '/' + imageName;
        },
        deleteSpace(b) {
            let pattern = [/[àáâãä]/i, /[éèëê]/i, /[ç]/i, /[ìíîï]/i, /[ñńņŉ]/i, /[òóôõö]/i, /[ùúûü]/i, /[ýÿ]/i, /[&]/i, /[.]/i, /[€]/i, /[/?]/i, /[/!]/i, /[/:]/i, /[']/i];
            let replace = ['a', 'e', 'c', 'i', 'n', 'o', 'u', 'y', '', '', '', '', '', '', ''];
            if(b != "") {
                b.trim();
                b = b.split(" ").join("_");
                for(var key in pattern) {
                    b = b.split(pattern[key]).join(replace[key]);
                }
            }
            return b;
        },
        deleteParenthesis(a) {
            if(a != null && a != '') {
                a = a.replace(/ \((.*)\)/, "");
                a.trim();
            }
            return a;
        },
        changeDescribeUrl(describe) {
            let firstString = ['src="/uploads', '/uploads/']
            let replace = ['src="https://cdn-gbbu02.graphibox.eu/pub', '/pub/'];
            if(describe != "") {
                for(var key in firstString) {
                    describe = describe.split(firstString[key]).join(replace[key]);
                }
            }
            return describe;
        }
    }
}